import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item", "stack"]
  static values = {
    html: String
  }

  connect() {
    this.timeouts = this.timeouts || new WeakMap()

    if (this.itemTargets.length === 0 && this.hasHtmlValue) {
      this.stackTarget.innerHTML = this.htmlValue
    }
  }

  disconnect() {
    this.itemTargets.forEach((item) => this.clearTimeout(item))
  }

  itemTargetConnected(element) {
    const timeout = Number(element.dataset.toastTimeout)

    if (!timeout || timeout <= 0) return

    const handle = window.setTimeout(() => this.dismiss(element), timeout)
    this.timeouts.set(element, handle)
  }

  itemTargetDisconnected(element) {
    this.clearTimeout(element)
  }

  dismiss(eventOrElement) {
    const element = eventOrElement?.target?.closest('[data-toast-target="item"]') || eventOrElement
    if (!(element instanceof HTMLElement)) return

    this.clearTimeout(element)
    element.classList.add("fade-out")
    window.setTimeout(() => element.remove(), 400)
  }

  clearTimeout(element) {
    if (!this.timeouts) return

    const handle = this.timeouts.get(element)
    if (!handle) return

    window.clearTimeout(handle)
    this.timeouts.delete(element)
  }
}
